<template>
	<div class="not-complete">
		该文档未完成
	</div>
</template>

<script>
	export default {
		name: "not-complete",
	}
</script>

<style lang="scss">
	.not-complete {
		padding: 16px;
	}
</style>
